


















import { Component, Watch, Prop } from 'vue-property-decorator'
import NotificationsListWrapper from '@share/notifications/NotificationsListWrapper.vue';
import PointsListWrapper from '@share/points/PointsListWrapper.vue';
import AnalyticsMixin from "@mixins/AnalyticsMixin";
import { InfoBlocksEnum } from "../../types/InfoBlocksEnum";
import MeetingsWrapper from "@share/meeting-view/MeetingsWrapper.vue";
import ChatView from "@service/views/ChatView.vue";
import {NotificationDataHelper} from "@share/notifications/helpers/NotificationDataHelper";
import FavoritesListWrapper from "@share/favorites/FavoritesListWrapper.vue";

@Component({
    name: 'ListBlocks',
    components: {FavoritesListWrapper, NotificationsListWrapper, PointsListWrapper, ChatView, MeetingsWrapper }
})
export default class ListBlocks extends AnalyticsMixin {

    @Prop({required: true}) notificationDataHelper: NotificationDataHelper | null;
    @Prop({required: true}) selectedUserId: number;

    openedBlock: InfoBlocksEnum = InfoBlocksEnum.empty;

    blockCustomConditions: Record<InfoBlocksEnum, () => boolean> = {
        [InfoBlocksEnum.meetings]: this.meetingsCustomCondition,
        [InfoBlocksEnum.empty]: this.emptyCustomConditions
    } as any;

    mounted() {
        this.$parent.$on('toggleFrontBlocks', this.toggleSomeBlock);
    }

    destroyed() {
        this.$parent.$off('toggleFrontBlocks', this.toggleSomeBlock);
    }

    close() {
        this.$router.push({path: this.$route.path})
    }

    @Watch('openedBlock')
    watchOpenedBlock(openedBlock: InfoBlocksEnum) {
        this.$emit("changeBlock", openedBlock)
    }

    meetingsCustomCondition() {
        return this.$store.getters['events/isMeetingsEnabled'];
    }

    emptyCustomConditions() {
        return this.openedBlock !== InfoBlocksEnum.empty;
    }

    @Watch('routeHash')
    onRouteHashChanged(routeHash: string) {
        const hashWithoutSharp = routeHash.split('_')[0].substring(1) || 'empty';

        if (Object.prototype.hasOwnProperty.call(InfoBlocksEnum, hashWithoutSharp)) {
            const blockName = Reflect.get(InfoBlocksEnum, hashWithoutSharp) as InfoBlocksEnum;

            let needToOpen = true;
            if (this.blockCustomConditions[blockName]) {
                needToOpen = this.blockCustomConditions[blockName]();
            }

            needToOpen && (this.openedBlock = blockName);
        }
    }

    toggleSomeBlock(value: InfoBlocksEnum) {
        //TODO: убрать зависимости от InfoBlocksEnum.sessions путем выноса логики показа наверх
        if(value !== InfoBlocksEnum.sessions) {
            if(this.openedBlock === value) {
                this.close();
            }
            else {
                this.$router.push({ hash: this.getHashString(value) })
            }
        }
        else if(this.openedBlock === InfoBlocksEnum.sessions) {
            this.close();
        }
    }

    getHashString(hashName: string) {
        return '#' + hashName;
    }

    get showChat() {
        return this.openedBlock === InfoBlocksEnum.chat && !this.selectedUserId;
    }

    get showRatings() {
        return this.openedBlock === InfoBlocksEnum.rating;
    }

    get showNotifications() {
        return this.openedBlock === InfoBlocksEnum.notifications;
    }

    get showMeetings() {
        return this.openedBlock === InfoBlocksEnum.meetings;
    }

    get isShowingContent() {
        return !!this.openedBlock && this.openedBlock !== InfoBlocksEnum.sessions;
    }

    get routeHash() {
        return this.$route.hash;
    }
}
